// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__39AJb","label":"Category_label__B62a4","content":"Category_content__j1Cp3","header":"Category_header__2lZVS","location":"Category_location__1DZxM"};